var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-login"},[_c('div',{staticClass:"c-login__body"},[_c('app-intro',[_c('h1',[_vm._v("Inloggen")])]),_c('login-form'),_c('ul',{staticClass:"c-login__list"},[_c('li',{staticClass:"c-login__item"},[_c('router-link',{staticClass:"c-login__link",attrs:{"to":"/forgot-password"}},[_vm._v("Wachtwoord vergeten?")])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }